import { render, staticRenderFns } from "./modal-lawyer-success.vue?vue&type=template&id=59ebe751&scoped=true&"
import script from "./modal-lawyer-success.vue?vue&type=script&lang=js&"
export * from "./modal-lawyer-success.vue?vue&type=script&lang=js&"
import style0 from "./modal-lawyer-success.vue?vue&type=style&index=0&id=59ebe751&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ebe751",
  null
  
)

export default component.exports